

<template>
  <v-container>

     <div style="border-style: solid; border-color: #2196F3">


           <div v-if="layer_index > -1">

<v-row>

            <v-col cols="12"  xs="12" sm="12" md="12">

                <v-row class="info_row" >
                                  <div>
                                     <v-list-item-title style="font-size: 24px" class="text-wrap">
                                      {{selectedLayer.text}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>(באלפים)</v-list-item-subtitle>
                                    <div v-if="selected_data.length > 0">
                                            
                                        <v-list-item-subtitle style="font-weight: bold;" v-if="selected_data"> {{selected_data[1]}} / {{selected_data[2]}}</v-list-item-subtitle>
                                            
                                        <v-avatar
                                        color="blue"
                                        size="70"
                                        >
                                        <span class="white--text text-h5">{{selected_data[6]}}</span>
                                        </v-avatar>

                                    </div>
                
                                    
                                    </div> 

                                </v-row>

                                <v-row class="info_row" > 
                                    
                                    <div v-if="selected_data.length > 0"> 
                                        <v-list-item-title style="font-size: 20px" class="text-wrap">
                                        צפיפות
                                        </v-list-item-title>
                                         <v-list-item-subtitle>צפיפות האוכלוסיה לקמ"ר יבשתי</v-list-item-subtitle>
                                        <v-avatar
                                         color="orange"
                                        size="65"
                                        >
                                        <span class="white--text text-h6">{{selected_data[10]}}</span>
                                        </v-avatar>

                                    </div>
                                    
                                </v-row>


                                <v-row style="margin: 5px;"  v-if="selected_data[6] > 0"> 
                                    <div> 
                                        
                                        <v-list-item-title style="font-size: 20px" class="text-wrap">
                                        התפלגות האוכלוסיה
                                        </v-list-item-title>
                                         <v-list-item-subtitle>לפי מגזר</v-list-item-subtitle>

                                    </div>

                                </v-row>

                                <v-row class="center info_row">
                                     <v-spacer></v-spacer> <doughnut-chart-area v-if="selected_data.length > 0" style="max-width:300px; max-height:250px" :cData="[selected_data[3],selected_data[4]]"></doughnut-chart-area><v-spacer></v-spacer>
                                </v-row>

                        
             </v-col>

</v-row>

           
                              

              </div>
     </div>

  </v-container>
</template>



<script>

import DoughnutChartArea from '@/components/DoughnutChartArea'
  export default {
    name: 'RegionDataDiv',
     components: {
         DoughnutChartArea
    },

    data: () => ({
        

    }),
    computed:{
      layer_index(){
        return this.$store.state.layer_index;
      },
      selectedLayer(){
        return this.$store.state.selectedLayer;
      },
      selected_data(){
        return this.$store.state.selected_data_natural;
      },
      img(){
        return this.$store.state.img;
      }
    },
    //props: ['layer_index', 'selected_data'],



  }

</script>

<style scoped>
.info_row{
  background: #FFFFFF 0% 0% no-repeat padding-box;
                        box-shadow: 0px 2px 7px #00000014;
                        opacity: 1; margin: 5px;
}
</style>
